import { useContext } from 'react';
import { TelemetryContext } from './TelemetryContext';
/**
 * Get the telemetry instance from the context
 * Throws an exception if used in a
 * component that is not a descendent of an `TelemetryProvider` component.
 */

export var useTelemetry = function useTelemetry() {
  var context = useContext(TelemetryContext);

  if (!context) {
    throw Error('Telemetry-aware components must be parented by an TelemetryProvider.');
  }

  var telemetry = context.telemetry;
  return telemetry;
};
//# sourceMappingURL=useTelemetry.js.map